import { render, staticRenderFns } from "./orders-rework-properties.vue?vue&type=template&id=b815e78a&scoped=true"
import script from "./orders-rework-properties.vue?vue&type=script&lang=js"
export * from "./orders-rework-properties.vue?vue&type=script&lang=js"
import style0 from "./orders-rework-properties.vue?vue&type=style&index=0&id=b815e78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815e78a",
  null
  
)

export default component.exports